/** ECharts 调色板 — 微信数据分析风
 *
 * 6 色覆盖典型多分类场景(来源/属性/漏斗分段):
 *   微信绿(主) / 微信蓝(链接) / 警示黄(主) / 红(警示) / 青(强调) / 中性灰
 */
export const WX_PALETTE: string[] = [
  '#07C160', // wxgreen — 主
  '#576B95', // wxblue — 链接
  '#FFC300', // amber — 警示
  '#FA5151', // red — 错误
  '#10AEFF', // cyan — 强调
  '#888888', // gray — 中性
];

/** 同色调深浅渐变 — 用于饼图分段(从主色到浅色) */
export const WX_GREEN_SHADES: string[] = [
  '#07C160',
  '#3FCF84',
  '#76DDA8',
  '#A8E7C4',
  '#C9F0D9',
  '#E7F8EE',
];

export const WX_TEXT = {
  primary:   '#1A1A1A',
  secondary: '#888888',
  axis:      '#BBBBBB',
} as const;

export const WX_BG = {
  card: '#FFFFFF',
  body: '#F7F7F7',
} as const;
